// True when the visitor has asked their OS for less motion; the 3D scenes stay off and the static art shows instead.
export const prefersReducedMotion = () => {
  return (
    typeof window !== "undefined" &&
    Boolean(window.matchMedia) &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
};
